<template>
  <div class="main">
    <div class="zhuce_form">
      <div class="zhuce">
        ELTMAX
        <span>管理系统注册</span>
      </div>
      <el-form ref="zhuceForm" :rules="zhuceFormRules" :model="zhuceForm">
        <el-form-item class="zhuce_input usname" prop="truename">
          <i class="icon_user">
            <img src="@/assets/img/register/uname.png" alt />
          </i>
          <input type="text" v-model="zhuceForm.truename" @keyup.13="zhuce" placeholder="请输入您的姓名" />
        </el-form-item>
        <el-form-item class="zhuce_input" prop="tel">
          <i class="icon_user">
            <img src="@/assets/img/register/phone.png" alt />
          </i>
          <input type="text" v-model="zhuceForm.tel" @keyup.13="zhuce" placeholder="请输入您的手机号码" />
        </el-form-item>
        <el-form-item class="zhuce_input" prop="smscode">
          <i class="icon_user">
            <img src="@/assets/img/register/code.png" alt />
          </i>
          <input v-model="zhuceForm.smscode" type="text" @keyup.13="zhuce" placeholder="请输入验证码" />
          <button @click="getCode(zhuceForm.tel)" class="codeBtn dz-cur" :disabled="!show">
            <span v-if="show">发送验证码</span>
            <span v-else class="count">{{count}} s</span>
          </button>
        </el-form-item>
        <el-form-item class="zhuce_input" prop="password">
          <i class="icon_user">
            <img src="@/assets/img/register/pass.png" alt />
          </i>
          <input v-model="zhuceForm.password" @keyup.13="zhuce" placeholder="请设置您的登录密码" />
        </el-form-item>
        <el-form-item class="zhuce_input" prop="orgname">
          <i class="icon_user">
            <img src="@/assets/img/register/mechanism.png" alt />
          </i>
          <input type="text" v-model="zhuceForm.orgname" @keyup.13="zhuce" placeholder="请输入您的机构名称" />
        </el-form-item>
        <el-form-item class="zhuce_button">
          <el-button type="primary" style="width: 100%" @click="zhuce()">立即注册</el-button>
        </el-form-item>
        <el-form-item class="zhuce_login">
          <el-button type="primary" style="width: 100%" @click="login()">返回登陆</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
const timeCount = 60;
export default {
  name: 'register',
  data() {
    return {
      zhuceForm: {
        truename: '',
        tel: '',
        smscode: '',
        password: '',
        orgname: '',
      },
      show: true,
      count: '',
      timer: null,
      // 标记code
      aginCode: '',
      zhuceFormRules: {
        truename: [{ required: true, message: '姓名必填', trigger: 'blur' }],
        tel: [
          { required: true, message: '手机号必填', trigger: 'blur' },
          { pattern: /^1[35789]\d{9}$/, message: '账号格式不对', trigger: 'blur' },
        ],
        smscode: [{ required: true, message: '请输入对应的验证码', trigger: 'blur' }],
        password: [{ required: true, message: '密码必填', trigger: 'blur' }],
        orgname: [{ required: true, message: '机构名称必填', trigger: 'blur' }],
      },
    };
  },
  methods: {
    login() {
      this.$router.push({ name: 'login' });
    },
    zhuce() {
      this.zhuceForm.md5password = this.$md5(this.zhuceForm.password);

      this.$refs.zhuceForm.validate((valid) => {
        if (valid) {
          console.log(this.zhuceForm.smscode, this.aginCode);
          if (this.zhuceForm.smscode !== this.aginCode) {
            return this.$message.error('请输入正确的验证码!');
          }
          let pro = this.$http({
            url: '/sys/user/backendUserRegister',
            method: 'POST',
            data: { truename: this.zhuceForm.truename, tel: this.zhuceForm.tel, password: this.zhuceForm.md5password, orgname: this.zhuceForm.orgname, smscode: this.zhuceForm.smscode },
          });
          pro
            .then((result) => {
              if (result.data.code === 0) {
                window.sessionStorage.setItem('userinfo', JSON.stringify(result.data.data.token));
                window.sessionStorage.setItem('username', result.data.data.username);
                // console.log(result)
                // console.log(result.data.data.token)
                this.$router.push({ name: 'home' });
              } else {
                this.$message.error(result.data.message);
                console.log(result);
              }
            })
            .catch((err) => {
              this.$message.error('系统错误：' + err);
            });
        }
      });
    },
    getCode(tel) {
      // 验证码倒计时
      var strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;

      if (strTemp.test(tel)) {
        if (!this.timer) {
          this.count = timeCount;
          this.show = false;

          let pro = this.$http({
            url: '/auth/sendSMS?username=' + this.zhuceForm.tel + '&type=register',
            method: 'POST',
          });
          pro
            .then((result) => {
              if (result.data.code !== 0) {
                return this.$message.error(result.data.message);
              }
              this.aginCode = result.data.data;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= timeCount) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            })
            .catch((err) => {
              return this.$message.error('获取失败：' + err);
            });
        }
        return true;
      }
      this.$message.error('请核对您的手机号!');
      return false;
    },
  },
};
</script>

<style lang="less">
.main {
  background: url(../../assets/img/register/bg.png);
  width: 100%;
  height: 100%;
  background-size: cover;
  .zhuce_form {
    position: fixed;
    top: 20%;
    left: 50%;
    .zhuce {
      font-size: 1.55vw;
      color: #0094ce;
      letter-spacing: 3px;
      font-weight: bold;
    }
    .usname {
      margin-top: 2.6vw;
    }
    .zhuce_input {
      height: 2.6vw;
      width: 17.4vw;
      margin-bottom: 1.1vw;
      .icon_user {
        position: relative;
        img {
          position: absolute;
          top: 0;
          left: 1.1vw;
        }
      }
      input {
        width: 100%;
        height: 100%;
        background: #f7f7f7;
        border-radius: 3px;
        border: 0px;
        font-size: 0.8vw;
        // padding-left: 3.4vw;
        padding: 0.87vw 0 0.87vw 3.4vw;
      }
      input:focus {
        outline: 0;
      }
      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #dadada;
      }
      .codeBtn {
        position: absolute;
        top: 8px;
        padding: 7px;
        right: -60px;
        z-index: 222;
        color: #0094ce;
        border: 1px solid #0094ce;
        font-size: 14px;
        border-radius: 10px;
      }
    }
    .zhuce_button {
      width: 20.85vw;
      margin-top: 2.2vw;
      .el-button {
        line-height: 1.3;
        background: rgba(0, 148, 206, 1);
        box-shadow: 2px 2px 6px rgba(0, 148, 206, 0.3);
        opacity: 1;
        border-radius: 34px;
        font-size: 0.9vw;
        letter-spacing: 2px;
      }
    }
    .zhuce_login {
      width: 20.85vw;
      margin-top: 0.6vw;
      .el-button {
        border: 2px solid #0094ce;
        line-height: 1.3;
        color: #0094ce;
        background: none;
        box-shadow: 2px 2px 6px rgba(249, 249, 249, 0.3);
        opacity: 1;
        border-radius: 34px;
        font-size: 0.9vw;
        letter-spacing: 2px;
      }
    }
  }
}
</style>
